module.exports = __webpack_public_path__ + "static/media/insta1.367057f2.png";